import BreakpointsService from "@services/breakpoint.service";

import { useIsBreakPoint } from "./useIsBreakPoint.hook";

const useIsMobile = () => {
    return useIsBreakPoint(BreakpointsService.matchesMaxSm);
};

export { useIsMobile };
